// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.__sortable_table {
  max-height: 70vh;
  overflow: scroll;
}
.__sortable_table ._sotable_table_row {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #090909;
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: 50px;
  align-items: center;
}
.__sortable_table ._sotable_table_row ._row_head {
  width: 25%;
}
.__sortable_table ._sotable_table_row ._row_head:first-child {
  padding-left: 20px;
}
.__sortable_table ._sotable_table_row ._row_head:not(:first-child) {
  text-align: center;
}
.__sortable_table ._sotable_table_row ._row_head:last-child {
  padding-right: 20px;
  text-align: right;
}
.__sortable_table ._sotable_table_row ._row_head:nth-child(2) {
  text-align: left;
}
.__sortable_table ._sotable_table_row ._row_head:nth-child(3) {
  text-align: right !important;
}
.__sortable_table .__sortable_table_body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 250px;
}
.__sortable_table .__sortable_table_body ._sortable_table_body_row {
  position: relative;
  display: flex;
  width: 100%;
  justify-content: space-between;
  min-height: 50px;
  align-items: center;
}
.__sortable_table .__sortable_table_body ._sortable_table_body_row:hover {
  background: #000000;
}
.__sortable_table .__sortable_table_body ._sortable_table_body_row ._sortable_td {
  width: 25%;
}
.__sortable_table .__sortable_table_body ._sortable_table_body_row ._sortable_td:last-child {
  padding-right: 20px;
}
.__sortable_table .__sortable_table_body ._sortable_table_body_row ._sortable_td:first-child {
  padding-left: 20px;
}
.__sortable_table .__sortable_table_body ._sortable_table_body_row ._sortable_td:nth-child(2) {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.__sortable_table .__sortable_table_body ._sortable_table_body_row ._sortable_td:nth-child(3) {
  text-align: right !important;
}
.__sortable_table .__sortable_table_body ._sortable_table_body_row ._sortable_td:nth-child(4) {
  text-align: right !important;
}

@media screen and (min-width: 577px) and (max-width: 833px) {
  .res {
    display: flex;
    flex-direction: column;
  }
}

@media screen and (min-width: 500px) and (max-width: 833px) {
  .res_artist {
    width: 100px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/MyMusic/index.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACE,gBAAA;AACJ;AAAE;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,yBAAA;EACA,aAAA;EACA,WAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;AAEJ;AADI;EACE,UAAA;AAGN;AAFM;EACE,kBAAA;AAIR;AADM;EACE,kBAAA;AAGR;AADM;EACE,mBAAA;EACA,iBAAA;AAGR;AADY;EACE,gBAAA;AAGd;AADM;EACE,4BAAA;AAGR;AACE;EAEE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,qBAAA;AAAJ;AACI;EACQ,kBAAA;EACA,aAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;AACZ;AACY;EACI,mBAAA;AAChB;AAEY;EACI,UAAA;AAAhB;AAEgB;EACI,mBAAA;AAApB;AAGgB;EACI,kBAAA;AADpB;AAGgC;EACV,aAAA;EACE,8BAAA;EACA,mBAAA;AADxB;AAGiC;EACE,4BAAA;AADnC;AAGgB;EACI,4BAAA;AADpB;;AASE;EADF;IAEI,aAAA;IACA,sBAAA;EALF;AACF;;AAQE;EADF;IAEM,YAAA;EAJJ;AACF","sourcesContent":[".__sortable_table {\n  max-height: 70vh;\n    overflow: scroll;\n  ._sotable_table_row {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background-color: #090909;\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    height: 50px;\n    align-items: center;\n    ._row_head {\n      width: 25%;\n      &:first-child {\n        padding-left: 20px;\n      }\n\n      &:not(:first-child) {\n        text-align: center;\n      }\n      &:last-child {\n        padding-right: 20px;\n        text-align: right;\n      }\n            &:nth-child(2) {\n              text-align: left ;\n            }\n      &:nth-child(3) {\n        text-align: right !important;\n      }\n    }\n  }\n  .__sortable_table_body{\n    \n    display: flex;\n    flex-direction: column;\n    gap:10px;\n    padding-bottom: 250px;\n    ._sortable_table_body_row {\n            position: relative;\n            display: flex;\n            width: 100%;\n            justify-content: space-between;\n            min-height: 50px;\n            align-items: center;\n    \n            &:hover {\n                background: #000000;\n            }\n    \n            ._sortable_td {\n                width: 25%;\n    \n                &:last-child {\n                    padding-right: 20px;\n                }\n    \n                &:first-child {\n                    padding-left: 20px;\n                }\n                                &:nth-child(2){\n                      display: flex;\n                        justify-content: space-between;\n                        align-items: center;\n                }\n                                 &:nth-child(3) {\n                                   text-align: right !important;\n                                 }\n                &:nth-child(4) {\n                    text-align: right !important;\n                }\n            }\n        }\n  }\n  \n}\n.res{\n  @media screen and (min-width: 577px) and (max-width: 833px){\n    display: flex;\n    flex-direction: column;\n  }\n}\n.res_artist{\n  @media screen and (min-width: 500px) and (max-width: 833px) {\n      width: 100px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
